import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import PrivateRoute from './components/PrivateRoute';
import Landing from './pages/Landing';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Strategy from './pages/Strategy';
import AutoTradingStrategy from './pages/AutoTradingStrategy';
import AutoTradingSector from './pages/AutoTradingSector';
import IndicatorTrading from './pages/IndicatorTrading';
// import VolatilityBreakout from './pages/VolatilityBreakout';
import TradingV21 from './pages/TradingV21';
import Holdings from './pages/Holdings';
import Account from './pages/Account';
import Settings from './pages/Settings';
import Report from './pages/Report';
import Terms from './pages/Terms';
import Privacy from './pages/Privacy';
import VerifyEmail from './pages/VerifyEmail';
import VerifyEmailSuccess from './pages/VerifyEmailSuccess';
import VerifyEmailError from './pages/VerifyEmailError';
import Layout from './components/Layout';

function App() {
  return (
    <AuthProvider>
      <ThemeModeProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/verify-email-success" element={<VerifyEmailSuccess />} />
            <Route path="/verify-email-error" element={<VerifyEmailError />} />
            <Route
              element={
                <PrivateRoute>
                  <Layout />
                </PrivateRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="strategy" element={<Strategy />} />
              <Route path="auto-trading" element={<AutoTradingStrategy />} />
              <Route path="auto-trading-sector" element={<AutoTradingSector />} />
              <Route path="indicator-trading" element={<IndicatorTrading />} />
              <Route path="trading-v2" element={<TradingV21 />} />
              <Route path="trading-v2-1" element={<Navigate to="/trading-v2" replace />} />
              {/* <Route path="volatility-breakout" element={<VolatilityBreakout />} /> */}
              <Route path="holdings" element={<Holdings />} />
              <Route path="account" element={<Account />} />
              <Route path="report" element={<Report />} />
              <Route path="settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </ThemeModeProvider>
    </AuthProvider>
  );
}

export default App;
